import {
    SIGNUP_SUCCESS,
    SIGNUP_FAIL,
    ACTIVATION_SUCCESS,
    ACTIVATION_FAIL,
    SET_AUTH_LOADING,
    REMOVE_AUTH_LOADING,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL,
    REFRESH_SUCCESS,
    REFRESH_FAIL,
    LOGOUT,

} from './types'
import * as authApi from '../../api/auth';
import { isTransientError } from '../../api/client';

// Registro de cuenta (endpoint de djoser).
export const signup = (first_name, last_name, email, phone, password, re_password) => async dispatch => {
    dispatch({
        type: SET_AUTH_LOADING,
    });
    try {
        const res = await authApi.signup({ first_name, last_name, email, phone, password, re_password });

        if (res.status === 201) {
            dispatch({
                type: SIGNUP_SUCCESS,
                payload: res.data
            });
            dispatch('Te enviamos un correo, por favor activa tu cuenta. Revisa el correo de spam')
        } else {
            dispatch({
                type: SIGNUP_FAIL
            });
            dispatch('Error en crear la cuenta, intente nuevamente')
        }
        dispatch({
            type: REMOVE_AUTH_LOADING
        });
    } catch (err) {
        dispatch({
            type: SIGNUP_FAIL
        });
        dispatch({
            type: REMOVE_AUTH_LOADING
        });
        dispatch('Error conectando con el servidor, intenta mas tarde.');
    }
};

export const activate = (uid, token) => async dispatch => {
    dispatch({
        type: SET_AUTH_LOADING,
    });
    try {
        const res = await authApi.activate({ uid, token });
        if (res.status === 204) {
            dispatch({
                type: ACTIVATION_SUCCESS,
            });

            dispatch('Activacion correcta.');
        } else {
            dispatch({
                type: ACTIVATION_FAIL
            });
            dispatch('Activacion erronea.');
        }
        dispatch({
            type: REMOVE_AUTH_LOADING
        });

    } catch (err) {
        dispatch({
            type: ACTIVATION_FAIL
        });
        dispatch({
            type: REMOVE_AUTH_LOADING
        });
        dispatch('El servidor no ha activado la cuenta.');

    }
}

export const login = (email, password) => async dispatch => {
    dispatch({
        type: SET_AUTH_LOADING
    });
    try {
        const res = await authApi.createToken({ email, password });
        if (res.status === 200) {
            dispatch({
                type: LOGIN_SUCCESS,
                payload: res.data
            });
            dispatch(load_user());
            dispatch({
                type: REMOVE_AUTH_LOADING
            });
            return { success: true };
        } else {
            dispatch({
                type: LOGIN_FAIL
            });
            dispatch({
                type: REMOVE_AUTH_LOADING
            });
            return { success: false };
        }
    }
    catch (err) {
        dispatch({
            type: LOGIN_FAIL
        });
        dispatch({
            type: REMOVE_AUTH_LOADING
        });
        return { success: false };
    }
}
export const forgotPassword = (email) => async dispatch => {
    try {
        const res = await authApi.forgotPassword(email);
        if (res.status === 200) {
            return { success: true };
        } else {
            return { success: false };
        }
    }
    catch (err) {
        return { success: false };
    }
}
export const passwordChange = (id, password, passwordNew, passwordValidate) => async dispatch => {
    if (localStorage.getItem('access')) {
        try {
            const res = await authApi.changePassword({ id, password, passwordNew, passwordValidate });
            if (res.status === 200) {
                return { success: true };
            } else {
                return { success: false };
            }
        }
        catch (err) {
            return { success: false, message: err.response?.data?.error };
        }
    }
}
export const load_user = () => async dispatch => {
    if (localStorage.getItem('access')) {
        try {
            const res = await authApi.getMe();

            if (res.status === 200) {
                dispatch({
                    type: USER_LOADED_SUCCESS,
                    payload: res.data
                });
            } else {
                dispatch({
                    type: USER_LOADED_FAIL
                });
            }
        }
        catch (err) {
            // Un 429 o un error de red no significa que la sesión sea inválida: se conserva el usuario.
            if (isTransientError(err)) return;
            dispatch({
                type: USER_LOADED_FAIL
            });
        }
    } else {
        dispatch({
            type: USER_LOADED_FAIL
        });
    }
}


// Verifica el token de acceso guardado, para mantener la sesión al recargar la página (lo usan Layout y ProtectedRoute).
export const check_authenticated = () => async dispatch => {
    if (localStorage.getItem('access')) {
        try {
            const res = await authApi.verifyToken(localStorage.getItem('access'));

            if (res.status === 200) {
                dispatch({
                    type: AUTHENTICATED_SUCCESS
                });
            } else {
                dispatch({
                    type: AUTHENTICATED_FAIL
                });
            }
        } catch (err) {
            // Solo un rechazo real del token (p. ej. 401) cierra la sesión; un 429 o un error de red no.
            if (isTransientError(err)) return;
            dispatch({
                type: AUTHENTICATED_FAIL
            });
        }
    } else {
        dispatch({
            type: AUTHENTICATED_FAIL
        });
    }
}

// Pide un token de acceso nuevo a partir del de refresco (lo usa Layout al cargar la página).
export const refresh = () => async dispatch => {
    if (localStorage.getItem('refresh')) {
        try {
            const res = await authApi.refreshToken(localStorage.getItem('refresh'));

            if (res.status === 200) {

                dispatch({
                    type: REFRESH_SUCCESS,
                    payload: res.data
                });
            } else {
                dispatch({
                    type: REFRESH_FAIL
                });
            }
        } catch (err) {
            // Ídem: con un 429 o un error de red se conservan los tokens.
            if (isTransientError(err)) return;
            dispatch({
                type: REFRESH_FAIL
            });
        }
    } else {
        dispatch({
            type: REFRESH_FAIL
        });
    }
}


export const logout = () => dispatch => {
    dispatch({
        type: LOGOUT
    });
}
